module.exports = __webpack_public_path__ + "medias/images/supplier-pin.png";